import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');

  const data = baseSeoUtil({
    site,
    siteConf,
    title: siteHumanReadable || 'Fast Company',
    twitterCard: 'summary',
    publisher: false,
    type: 'website'
  });

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/homepage_seo_util.js